module.exports = __webpack_public_path__ + "static/media/2014 Canada.39894889.jpg";